import React from "react";
import ArrowCircleRight from "../../../../svg/ArrowCircleRight";
import Modal from "../../Modal";
import { Button, TextModal, WrapperButton } from "./styled";

interface WarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const WarningModal: React.FC<WarningModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen}>
      <TextModal>
        Você precisa preencher todos campos para poder completar a assinatura!
      </TextModal>
      <WrapperButton>
        <Button
          backgroundColor="#77EC84"
          hoverBackgroundColor="#72E27F"
          onClick={onClose}
        >
          Confirmar
          <ArrowCircleRight />
        </Button>
      </WrapperButton>
    </Modal>
  );
};

export default WarningModal;
